import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Required from '../Required/Required'

import DropDown from '../../../assets/fieldset-drop-down.svg'

import './Fieldset.css'

const Fieldset = ({
  label,
  children,
  instructions,
  name,
  required,
  collapsable = false,
  collapsed: initialCollapsed = false
}) => {
  const [collapsed, collapse] = useState(collapsable && initialCollapsed)
  return (
    <fieldset data-testid='fieldset-group' styleName={cx('fieldset', { collapsed })}>
      <legend data-testid='fieldset-legend' styleName='legend'>
        <div
          data-testid='fieldset-collapser'
          styleName='flex'
          onClick={() => collapsable && collapse(!collapsed)}
        >
          <span>
            <div data-testid='fieldset-label' styleName='label'>{label}</div>
            {instructions ? (
              <span data-testid='fieldset-instructions' styleName='instructions'>{instructions}</span>
            ) : null}
          </span>
          {required ? <Required name={name} /> : null}
          {collapsable ? <DropDown styleName='dropDown' /> : null}
        </div>
      </legend>
      <div data-testid='fieldset-children' styleName='children'>{children}</div>
    </fieldset>
  )
}

export default Fieldset

Fieldset.propTypes = {
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
  required: PropTypes.bool,
  instructions: PropTypes.node,
  collapsable: PropTypes.bool,
  collapsed: PropTypes.bool
}
